import { useEffect, useRef, useState } from "react";

import { Button } from "primereact/button";
import { Card } from "primereact/card";
import { InputNumber } from "primereact/inputnumber";
import { Toast } from "primereact/toast";

import Loading from "../components/Loading";
import Menu from "../components/Menu";

import api from "../services/api";

export default function Configuracao() {
    const [config, setConfig] = useState(null);
    const [loading, setLoading] = useState(false);

    const toast = useRef(null);

    const handleUpdate = () => {
        if(config.teares === '' || config.teares === '' || config.eficiencia_minima === '') {
            toast.current.show({
                summary: 'Aviso',
                severity: 'warn',
                detail: 'Preencha os campos obrigatórios antes de prosseguir'
            });
            return;
        }
        setLoading(true);
        api.post('configuracao/update', config).then((response) => {
            setConfig(response.data.config);
            setLoading(false);

            toast.current.show({
                summary: 'Concluído',
                severity: 'success',
                detail: response.data.message
            });
        }).catch((error) => {
            setLoading(false);
            toast.current.show({
                summary: 'Ocorreu um Erro',
                severity: 'error',
                detail: error.response.data.message
            });
        });
    }

    useEffect(() => {
        setLoading(true);
        api.get('configuracao').then((response) => {
            setConfig(response.data);
            setLoading(false);
        }).catch((error) => {
            setLoading(false);
            toast.current.show({ 
                summary: 'Ocorreu um Erro', 
                severity: 'error', 
                detail: 'Não foi possível conectar ao servidor. Caso persista, entre em contato com o setor de TI.' 
            });
        });
    }, []);

    if (loading) {
        return (
            <Loading />
        )
    }

    return (
        <div>
            <Menu />
            <Toast ref={toast} />
            <div className="p-d-flex p-jc-center" >
                <Card className="p-m-3" title="Configuração" style={{ minWidth: '30vw' }}>
                    <div className="p-fluid">
                        <div className="p-field">
                            <label htmlFor="teares">Nº de Teares: </label>
                            <InputNumber
                                disabled={config !== null ? false : true}
                                onChange={e => setConfig({...config, teares: e.value})}
                                placeholder="Exemplo: 72"
                                value={config !== null ? config.teares : ''}
                            />
                        </div>
                        <div className="p-field">
                            <label htmlFor="grupos">Nº de Grupos: </label>
                            <InputNumber
                                disabled={config !== null ? false : true}
                                onChange={e => setConfig({...config, grupos: e.value})}
                                placeholder="Exemplo: 6"
                                value={config !== null ? config.grupos : ''}
                            />
                        </div>
                        <div className="p-field">
                            <label htmlFor="eficiencia_minima">Eficiencia Mínima: </label>
                            <InputNumber 
                                disabled={config !== null ? false: true}
                                onChange={e => setConfig({...config, eficiencia_minima: e.value})}
                                placeholder="10%"
                                max={100}
                                maxFractionDigits={2}
                                mode="decimal"
                                value={config !== null ? config.eficiencia_minima : ''}
                            />
                        </div>
                        <div className="p-field">
                            <label htmlFor="eficiencia_baixa">Eficiencia Baixa: </label>
                            <InputNumber 
                                disabled={config !== null ? false : true}
                                onChange={e => setConfig({...config, eficiencia_baixa: e.value })}
                                placeholder="85%"
                                max={100}
                                maxFractionDigits={2}
                                mode="decimal"
                                value={config !== null ? config.eficiencia_baixa : ""}
                            />
                        </div>
                        <div className="p-field">
                            <Button disabled={config !== null ? false : true} label="Salvar" onClick={handleUpdate} />
                        </div>
                    </div>
                </Card>
            </div>
        </div>
    )
}